module.exports = __webpack_public_path__ + "static/user-01-49550dd09ce60c2b1d9df1a08a4dcf54.png";